import React from 'react';
import Home from './Home';
import Header from './component/Header';
import { Routes , Route, NavLink} from 'react-router-dom';
import Roadmap from './Roadmap';
import Qantum from './Qantum';
import Footer from './component/Footer';
import Team from './component/Team';
import HandNotes from './HandNotes';
import Projects from './Projects/Projects';
import Frequent from './Frequent';
import Footera from './component/Footera';
import Papers from './Papers';
import Ai from './Ai';
import Resume from './Resume';
import './App1.css'
import InterviewPrep from './component/InterviewPrep/InterviewPrep';

import Error from './Error/Error';
import Faq from './Faq/Faq';
import Data from './Information/Data/Data'
import DataCard from './Information/Data/DataCard';
import ScrollToTop from './ScrollToTop';
import Contact from './Contact/Contact';


const App1 = () => {
  let mybutton = document.getElementById('myBtn');
  window.onscroll = function(){scrollFunction()};

  function scrollFunction(){
    if(document.body.scrollTop > 20 || document.documentElement.scrollTop > 20){
      mybutton.style.display = "block";
    }else{
      mybutton.style.display = "none";
    }
  }

  function topFunction(){
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  } 
  
  return (







    <>

        <ScrollToTop />
        <Header/> 
        <div className='navbar_pos'></div> 

        <div className="view">
        <div className="laptop_view">

          
        <Routes>


            <Route path='/'element={<Home/>}/>
            <Route path='/developer-roadmaps' element={<Roadmap/>}/>
            <Route path='/handwritten-notes-pdf' element={<HandNotes/>}/>
            <Route path='/Team' element={<Team/>}/>
            <Route path="/resume-maker-online" element={<Resume/>}/>            
            <Route path="/basic-interview-questions-and-answers" element={<InterviewPrep/>}/>      
            
            <Route path="/aktu-quantum-books" element={<Qantum/>}>
              <Route path="/aktu-quantum-books/mechanical-engineering"></Route>
              <Route path="/aktu-quantum-books/electrical-engineering"></Route>
              <Route path="/aktu-quantum-books/information-technology"></Route>
              <Route path="/aktu-quantum-books/cse"></Route>
              <Route path="/aktu-quantum-books/civil-engineering"></Route>
              <Route path="/aktu-quantum-books/electronics-engineering"></Route>
            </Route>

            <Route path="/previous_years" element={<Papers/>}>
              <Route path="/previous_years/mechanical-engineering"></Route>
              <Route path="/previous_years/electrical-engineering"></Route>
              <Route path="/previous_years/information-technology"></Route>
              <Route path="/previous_years/cse"></Route>
              <Route path="/previous_years/civil-engineering"></Route>
              <Route path="/previous_years/electronics-engineering"></Route>
            </Route>


            <Route path="/projects" element={<Projects/>}>
              <Route path="/projects/mechanical-engineering-project-report-pdf"></Route>
              <Route path="/projects/electrical-engineering-project-report-pdf"></Route>
              <Route path="/projects/chemical-engineering-project-report-pdf"></Route>
              <Route path="/projects/computer-science-engineering-project-report-pdf"></Route>
            </Route>

            <Route path="/data" element={<Data/>}>
              <Route path="/data/dsa"/>
              <Route path="/data/c++"/>
              <Route path="/data/java"/>
              <Route path="/data/python"/>
              <Route path="/data/web-development"/>
              <Route path="/data/app-development"/>
              <Route path="/data/data-science"/>
              <Route path="/data/machine-learning"/>
              <Route path="/data/auot-cad"/>
              <Route path="/data/solid-works"/>
              <Route path="/data/graphic-designing"/>
              <Route path="/data/video-editing"/>
              <Route path="/data/content-writing"/>
            </Route>  

            <Route path="*" element={<Error/>}/>   
            <Route path="/FaqPage" element={<Faq/>}/>
            <Route path="/Contact" element={<Contact/>}/>


        </Routes>


        </div>
        </div>





<Routes>
  <Route to="/Contact" element={<Contact/>}></Route>
  <Route to="FaqPage" element={<Faq/>}></Route>
</Routes>




        <Footera/>
        <Footer/>
        
        <button onClick={topFunction} id="myBtn" ><i class="zmdi zmdi-chevron-up"></i></button>
        <NavLink to="/"  id="home_button" ><i class="zmdi zmdi-home"></i></NavLink>

        
    </>



  )
}

export default App1